import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export default function PushNotificationManager() {
  const { user } = useAuth();
  const registered = useRef(false);

  useEffect(() => {
    if (!user || registered.current) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    registered.current = true;

    const register = async () => {
      try {
        const reg = await navigator.serviceWorker.register('/sw-push.js');
        const { data } = await axios.get(`${API}/push/vapid-key`);
        if (!data.public_key) return;

        const existing = await reg.pushManager.getSubscription();
        if (existing) {
          await axios.post(`${API}/push/subscribe`, { subscription: existing.toJSON() }, { withCredentials: true });
          return;
        }

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        const sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(data.public_key)
        });
        await axios.post(`${API}/push/subscribe`, { subscription: sub.toJSON() }, { withCredentials: true });
      } catch (err) {
        console.log('Push registration skipped:', err.message);
      }
    };

    // Delay to not block initial load
    setTimeout(register, 3000);
  }, [user]);

  return null;
}
